import { CoreIcon } from '../core-icon';
import bankLinepayMonoSVG from '../../assets/logos/bank-linepay-mono.svg';
import type { IconProps } from '../core-icon';

export const BankLinepayMonoIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={bankLinepayMonoSVG} {...props} />;
};
